const accessibleLinkCards = () => {

	const selectors = ['.wcag-card']; // add elements to array if needed

	const cardElements = document.querySelectorAll(selectors.join(', '));
	if (!cardElements.length) return;

	cardElements.forEach((card) => {

		const firstAnchor = card.querySelector('a');
		if (!firstAnchor) return;

		const anchorUrl = firstAnchor.href;
		const anchorTarget = firstAnchor.target;

		const navigateToLink = () => {
			if (anchorTarget === '_blank') {
				window.open(anchorUrl, "_blank");
			} else {
				window.location.href = anchorUrl;
			}
		};

		const handleCardClick = (event) => {
			// Only navigate if the user didn't click on an interactive element directly.
			if (!event.target.closest('a, button, input')) {
				navigateToLink();
			}
		};

		const handleCardKeydown = (event) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				navigateToLink();
			}
		};


		const getAccessibleName = () => {
			// use heading
			const heading = card.querySelector('h1, h2, h3, h4, h5, h6');
			if (heading && heading.textContent.trim()) {
				return heading.textContent.trim();
			}

			// if not, use link text
			if (firstAnchor.textContent.trim()) {
				return firstAnchor.textContent.trim();
			}

			// if not, use aria-label
			if (firstAnchor.getAttribute('aria-label')) {
				return firstAnchor.getAttribute('aria-label');
			}

			// generic
			return 'Read more';
		}

		// remove tab focus from all nested links to avoid redundant focus stops
		const allLinks = card.querySelectorAll('a');
		allLinks.forEach((link) => {
			link.setAttribute('tabindex', '-1');
		});

		// Set WCAG attributes on the card itself.
		card.style.cursor = 'pointer';
		card.setAttribute('tabindex', '0');
		card.setAttribute('role', 'link');
		card.setAttribute('aria-label', getAccessibleName());

		// allow for text selection.
		card.addEventListener('click', (event) => {
			if (window.getSelection().toString().length === 0) {
				handleCardClick(event);
			}
		});

		card.addEventListener('keydown', handleCardKeydown);

	});
};

export { accessibleLinkCards };